module.exports = __webpack_public_path__ + "img/prog_layout1.6af96c12.png";